<template>
  <div class="modal fade" id="createFAQModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 v-if="!editing" class="modal-title">
            New FAQ
          </h5>
          <h5 v-if="editing" class="modal-title">
            Edit FAQ
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="saveFAQ">
            <div class="form-group">
              <label for="question">Question</label>
              <input
                type="text"
                class="form-control"
                id="question"
                placeholder="Question"
                required
                v-model="question"
              />
            </div>
            <div class="form-group">
              <label for="answer">Answer</label>
              <textarea
                type="text"
                class="form-control"
                id="answer"
                placeholder="Answer"
                rows="6"
                required
                v-model="answer"
              />
            </div>

            <div class="text-right">
              <button
                v-if="editing"
                type="button"
                v-on:click="deleteFAQ"
                class="float-left btn btn-danger"
              >
                Delete FAQ
              </button>
              <button v-if="editing" class="btn btn-primary">
                Update FAQ
              </button>
              <button v-if="!editing" type="submit" class="btn btn-primary">
                Create FAQ
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "CreateFAQModal",
  props: {
    FAQToEdit: Object
  },
  data() {
    return {
      question: "",
      answer: "",
      editingFAQ: null,
      editing: false
    };
  },
  watch: {
    FAQToEdit: function() {
      if (this.FAQToEdit != null) {
        this.question = this.FAQToEdit.Question;
        this.answer = this.FAQToEdit.Answer;
        this.editingFAQ = this.FAQToEdit;
        this.editing = true;
      } else {
        this.clearFields();
        this.editing = false;
      }
    }
  },
  mounted() {
    $("#createFAQModal").on("shown.bs.modal", function() {
      $("#question").focus();
    });
  },
  methods: {
    async saveFAQ() {
      if (this.editing) {
        await this.updateFAQ();
      } else {
        await this.createFAQ();
      }
    },
    async createFAQ() {
      var view = this;
      $("#createFAQModal").modal("hide");
      view.$store.commit("updateLoading", true);
      var faqToCreate = {
        Question: view.$data.question,
        Answer: view.$data.answer
      };
      await this.$createFAQ(faqToCreate)
        .then(newFAQ => {
          view.$emit("addedFAQ", newFAQ);
          view.$store.commit("updateLoading", false);
          view.clearFields();
        })
        .catch(e => {
          console.log(e);
          $("#createFAQModal").modal("show");
          view.$store.commit("updateLoading", false);
        });
    },
    async updateFAQ() {
      var view = this;
      $("#createFAQModal").modal("hide");
      view.$store.commit("updateLoading", true);
      var faqToUpdate = {
        FAQ_Id: view.$data.editingFAQ.FAQ_Id,
        Question: view.$data.question,
        Answer: view.$data.answer
      };
      await this.$updateFAQ(faqToUpdate)
        .then(editedFAQ => {
          view.$emit("editedFAQ", editedFAQ);
          view.$store.commit("updateLoading", false);
          view.clearFields();
        })
        .catch(e => {
          console.log(e);
          $("#createFAQModal").modal("show");
          view.$store.commit("updateLoading", false);
        });
    },
    async deleteFAQ() {
      var view = this;
      $("#createFAQModal").modal("hide");
      await this.$deleteFAQ(view.editingFAQ)
        .then(() => {
          view.$emit("deletedFAQ", view.editingFAQ.FAQ_Id);
          view.clearFields();
        })
        .catch(e => {
          console.log(e);
          $("#createFAQModal").modal("show");
          view.$store.commit("updateLoading", false);
        });
    },
    clearFields() {
      this.question = "";
      this.answer = "";
      this.editingFAQ = null;
    }
  }
};
</script>
